const init = () => {
  const observer = new MutationObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.addedNodes &&
        entry.target &&
        (entry.target as HTMLElement).classList.contains('yotpo-footer-layout')
      ) {
        document.documentElement.style.setProperty(
          '--yotpo-bar',
          `${(entry.target as HTMLElement).offsetHeight}px`,
        );

        observer.disconnect();
      }
    });
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
  });
};

document.addEventListener('DOMContentLoaded', init);
